import axios from "axios";

//AuthService
export default {
	token: "",
	user: null,
	getUserPromise: null,
	queuedRefresh: null,

	//Gets the logged in user, pass allowCache = true to prevent doing a server call when it's not necessary
	getUser(allowCache) {
		if (!this.getUserPromise || !allowCache || this.queuedRefresh) {
			this.queuedRefresh = null;

			//check browser url for token
			// var params = new URLSearchParams(window.location.search)

			// URLSearchParams don't seem to work with hash (#) urls that vue uses to navigate
			// Looks like we have to parse it out manually if we stay with this implementation
			var token = null;
			var pathParts = window.location.href.split("?hash=");
			if (pathParts.length > 1) {
				token = pathParts[1];
			}

			var reqConfig = {};
			if (token) {
				this.setToken(token);
				console.log("Found token: " + token)
				reqConfig = {
					headers: { 'X-Auth-Token': token }
				}
			}

			this.getUserPromise = new Promise((resolve, reject) => {
				axios
					.get("/v1/me", reqConfig)
					.then(resp => {
						var user = resp.data.data;
						if (user) {
							resolve(user);
						} else {
							reject(resp.data);
						}
					})
					.catch(err => {
						reject(err);
					});
			});
		}
		return this.getUserPromise;
	},

	getUserNoDistrict() {
		return axios.get(`/v1/me_no_district`)
	},

	forceRefresh() {
		this.queuedRefresh = true;
	},

	//clearState clears out the auth information
	clearState() {
		//TODO clear cookie just to be sure
		this.getUserPromise = null;
		this.token = "";
		axios.defaults.headers.common["X-Auth-Token"] = this.token;
	},

	//Logs the user in and set up auth for future requests
	login(username, password) {
		return new Promise((resolve, reject) => {
			axios
				.post("/v1/login", {
					email: username,
					password: password
				})
				.then(data => {
					console.log("POST LOGIN", data);
					// this.setToken(data.data.data);

					// Short circuit if the response is anything other than a normal success
					if (data.data.message != "success") {
						resolve(data)
						return
					}

					this.getUser()
						.then(resp => {
							resolve(resp)
						}).catch(err => {
							reject(err)
						})
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	loginAs(userID) {
		return new Promise((resolve, reject) => {
			axios.post(`/v1/login_as/${userID}`)
			.then(data => {
				console.log("POST LOGIN", data);
				// this.setToken(data.data.data);

				// Short circuit if the response is anything other than a normal success
				if (data.data.message != "success") {
					resolve(data)
					return
				}

				this.getUser()
					.then(resp => {
						resolve(resp)
					}).catch(err => {
						reject(err)
					})
			})
			.catch(err => {
				reject(err);
			});
		})
	},

	setToken(token) {
		if (!token) {
			console.error("no token!")
		}
		console.log("setting token", token);
		//We don't really have to store the token, we'll use the "oscar" cookie until we see reasons otherwise
		this.token = token;
		//It seems like any requests that happen within this resolve do not carry the cookie so we'll set this here. Cookie will be used on page refresh
		axios.defaults.headers.common["X-Auth-Token"] = this.token;
	},

	// Logs the user out and navigates to sign-in page
	logout(vue) {
		var _this = this;
		return new Promise(() => {
			axios.get("/v1/logout").then(function () {
				_this.clearState();
				vue.$router.push({
					path: "/"
				});
			}).catch(e => {
				console.log(e)
				_this.clearState();
				vue.$router.push({
					path: "/"
				});
			});
		});
	},

	resetPassword(email) {
		return axios.post("/v1/reset_pass_email", {
			email: email
		});
	},

	setNewPassword(token, password) {
		return axios.post("/v1/resetPass", {
			token: token,
			password: password
		});
	},

	pickRoleStudent() {
		// TODO: Add some kind of context/authentication
		return axios.post("/v1/pick_role/student")
	},

	pickRoleTeacher() {
		// TODO: Add some kind of context/authentication
		return axios.post("/v1/pick_role/teacher")
	},

	pickRolePartner() {
		// TODO: Add some kind of context/authentication
		return axios.post("/v1/pick_role/partner")
	},

	applyJoinCode(code, role) {
		let ctx = {
			code: code,
			role: role,
		}
		return axios.post(`/v1/apply_code`, ctx)
	},

	applyJoinClassCode(code, role) {
		let ctx = {
			code: code,
			role: role,
		}
		return axios.post(`/v1/apply_class_code`, ctx)
	},

	checkJoinCode(code, role) {
		let ctx = {
			code: code,
			role: role,
		}
		return axios.post(`/v1/check_code`, ctx)
	},

	createAccount(email, password, name, role, code) {
		let ctx = {
			email: email,
			password: password,
			name: name,
			role: role,
			code: code
		}

		return axios.post(`/v1/create_account`, ctx)
	},

	getAppUrl() {
		return axios.get(`/v1/app_url`)
	},

	getVersion() {
		return axios.get("/v1/version");
	}
};
